import React from "react";

const shipRegistrationRoutes = [
    {
        path: "/vessel/shipRegistration/list",
        component: React.lazy(() =>
            import("./ShipRegList")
        )
    },
    {
        path: "/vessel/shipRegistration/:viewType/:shiRegNo",
        component: React.lazy(() =>
            import("./ShipRegFormDetails")
        )
    }
];

export default shipRegistrationRoutes;